export const costBreakdownFragment = `
  fragment AiCostBreakdownParts on CostBreakdown {
    budgetRange {
      price {
        amount {
          value
          min
          max
        }
        unit
        currency
      }
    }
    ceremony {
      price {
        amount {
          value
          min
          max
        }
        unit
        currency
        type
      }
    }
    catering {
      price {
        amount {
          value
          min
          max
        }
        unit
        currency
        type
      }
    }
    barServices {
      price {
        amount {
          value
          min
          max
        }
        unit
        currency
        type
      }
    }
    reception {
      price {
        amount {
          value
          min
          max
        }
        unit
        currency
        type
      }
    }
  }
`;
